import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=23a364a6&"
import script from "./StockOverview.vue?vue&type=script&lang=js&"
export * from "./StockOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports